module.exports = __webpack_public_path__ + "static/media/yt.0f00b103.svg";